"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = exports.iconSources = void 0;
const react_1 = __importDefault(require("react"));
const GenericIconMap_1 = __importDefault(require("./Generics/GenericIconMap"));
const MatrixResourceMap_1 = __importDefault(require("./MatrixResources/MatrixResourceMap"));
exports.iconSources = {
    generic: GenericIconMap_1.default,
    matrix: MatrixResourceMap_1.default,
    component: [],
};
/**
 * Renders an icon based on the resource source and the icon name
 * @param {{resourceSource?: ResourceSources; icon?: IconOptions; props: React.HTMLAttributes<HTMLOrSVGElement>}} props - The props for the Icon component
 * @returns {React.FunctionComponent} - The icon component
 * @example
 * <Icon />
 * @example
 * <Icon resourceSource="generic" icon="generic_file" />
 * @example
 * <Icon resourceSource="matrix" icon="page" />
 * @example
 * <Icon resourceSource="matrix" icon="page" height={24} width={24} />
 * @example
 * <Icon resourceSource="matrix" icon="page" className="custom-class" />
 */
function Icon({ resourceSource = 'generic', icon, componentIcon, isDecorative = true, ...props }) {
    if (resourceSource === 'component' && componentIcon !== undefined) {
        const className = props?.className || '';
        return react_1.default.createElement("div", { className: className }, componentIcon);
    }
    const icons = exports.iconSources[resourceSource] || null;
    // If the resource source is the current source and the icon is in the current source map, render the icon
    if (icons && icon && icon in icons) {
        // Get the icon from the current source map
        const Icon = icons[icon];
        // Render the icon
        return react_1.default.createElement(Icon, { isDecorative: isDecorative, ...props });
    }
    // If the icon is not defined, render the default icon
    const DefaultIcon = MatrixResourceMap_1.default['generic_file'];
    return react_1.default.createElement(DefaultIcon, { isDecorative: isDecorative, ...props });
}
exports.Icon = Icon;
